module.exports = __webpack_public_path__ + "static/media/37_B.2a462171.png";